export const helpLinkConfig = {
  default: "https://logicleap-tech.atlassian.net/servicedesk/customer/portal/1",
  routes: {
    "/profile": {
      "Student": "https://logicleap-tech.atlassian.net/servicedesk/customer/kb/view/102891523",
    },
    "/log-reports/*": "https://logicleap-tech.atlassian.net/servicedesk/customer/kb/view/102957069",
    "/evaluations/*": "https://logicleap-tech.atlassian.net/servicedesk/customer/kb/view/99876865",
    "/student-overview/evaluation/*": "https://logicleap-tech.atlassian.net/servicedesk/customer/kb/view/99876865",
  },
};

export const getHelpLink = (pathname, role) => {
  let helpLink = helpLinkConfig.default;

  for (const route in helpLinkConfig.routes) {
    // eslint-disable-next-line no-prototype-builtins
    if (helpLinkConfig.routes.hasOwnProperty(route)) {
      if (route.endsWith("/*")) {
        const basePath = route.slice(0, -2);
        if (pathname.startsWith(basePath)) {
          const routeConfig = helpLinkConfig.routes[route];
          if (typeof routeConfig === 'string') {
            helpLink = routeConfig;
          } else if (routeConfig[role]) {
            helpLink = routeConfig[role];
          } else {
            helpLink = routeConfig; // Fallback to route-based link (object)
          }
          break; // Stop searching once a wildcard match is found
        }
      } else if (route === pathname) {
        const routeConfig = helpLinkConfig.routes[route];
        if (typeof routeConfig === 'string') {
          helpLink = routeConfig;
        } else if (routeConfig[role]) {
          helpLink = routeConfig[role];
        } else {
          helpLink = routeConfig; // Fallback to route-based link (object)
        }
        break; // Stop searching once an exact match is found
      }
    }
  }

  return helpLink;
};